import React, { useState } from "react";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DatePickerCustomInput from "../DatePickerCustomInput";
import * as S from "./styles";

export default function BorderedDatePicker({
  disabled,
  label,
  selected,
  setSelected,
}) {
  return (
    <S.Wrapper>
      <S.Main>
        <S.Label>{label}</S.Label>
        <DatePicker
          dateFormat="dd/MM/yyyy"
          disabled={disabled}
          selected={selected}
          onChange={setSelected}
          customInput={<DatePickerCustomInput />}
        />
      </S.Main>
    </S.Wrapper>
  );
}
